<div class="base-knowledge">
    <div class="category-container" *ngFor="let category of filteredCategoryList">
        <div *ngIf="!(isDevelopment && category.EditMode)" class="category-container__header" (click)="toggleCategory(category)">
            <div class="category-container__header-title">
                <bzg-icon [nameIcon]="category.Expanded ? 'icon-arrow-down-black' : 'icon-arrow-right-black'" [size]="14"></bzg-icon>
                <span>{{ category.DisplayName }}</span>
            </div>
            
            <bzg-button-secondary 
                type="button" 
                icon="icon-plus" 
                *ngIf="category.EditMode" 
                (click)="addNewCatalog(category, $event)" 
                [size]="'s'" 
                [title]="'BASEKNOWLEDGECATALOG.ADD_CATALOG' | translate"
                class="category-container__add-catalog tooltip-container">
                {{ 'BASEKNOWLEDGECATALOG.ADD_CATALOG' | translate }}
            </bzg-button-secondary>
        </div>
        <div *ngIf="category.Expanded">
            <div *ngFor="let catalog of getSortedCatalogs(category)">
                <div class="category-container__catalog" (click)="toggleCatalog(catalog)">
                    <div class="category-container__catalog-title">
                        <bzg-icon [nameIcon]="catalog.Expanded ? 'icon-arrow-down-black' : 'icon-arrow-right-black'" [size]="14"></bzg-icon>
                        <span class="category-container__catalog-title-label">{{ catalog.DisplayName }}</span>
                    </div>
                    <bzg-icon *ngIf="category.EditMode" [nameIcon]="'icon-dots-more'" [size]="14"
                    [bzgMenuTrigger]="optionsMenu" [bzgMenuYPosition]="'below'" [bzgMenuXPosition]="'before'"
                    (click)="$event.stopPropagation()"></bzg-icon>

                </div>

                <bzg-menu #optionsMenu>
                    <bzg-menu-item (click)="editCatalog(catalog)" class="category-container__add-artifact">
                        <bzg-icon class="bz-trace-node-list-menu-icon bz-space--inline-s" [nameIcon]="'icon-edit'">
                        </bzg-icon>
                        <span class="category-container__add-artifact-label">{{ 'BASEKNOWLEDGECATALOG.EDIT_CATALOG' | translate }}</span>
                    </bzg-menu-item>
                    <bzg-menu-item (click)="deleteCatalog(catalog)" class="category-container__add-artifact">
                        <bzg-icon class="bz-trace-node-list-menu-icon bz-space--inline-s" [nameIcon]="'icon-delete'">
                        </bzg-icon>
                        <span class="category-container__add-artifact-label">{{ 'BASEKNOWLEDGECATALOG.DELETE_CATALOG' | translate }}</span>
                    </bzg-menu-item>
                </bzg-menu>
                <table *ngIf="catalog.Expanded && catalog.KBArtifacts.length > 0" class="category-container__table">
                    <thead>
                        <tr>
                            <th>{{ 'BASEKNOWLEDGECATALOG.TABLE.NAME' | translate }}</th>
                            <th>{{ 'BASEKNOWLEDGECATALOG.TABLE.FILE' | translate }}</th>
                            <th>{{ 'BASEKNOWLEDGECATALOG.TABLE.DESCRIPTION' | translate }}</th>
                            <th>{{ 'BASEKNOWLEDGECATALOG.TABLE.STATUS' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let artifact of catalog.KBArtifacts">
                            <tr *ngIf="!artifact.Deleted">
                                <td title="{{ artifact.DisplayName }}">{{ artifact.DisplayName }}</td>
                                <td>
                                    <div class="category-container__table-file">
                                        <bzg-icon [nameIcon]="'icon-file-color'"></bzg-icon>
                                        <span title="{{ artifact.FileName }}">{{ artifact.FileName }}</span>
                                    </div>
                                </td>
                                <td title="{{ artifact.Description }}">{{ artifact.Description }}</td>
                                <td>
                                    <div class="status" title="{{ artifact.ArtifactStatusLocalized }}">
                                        <span class="status-dot" [ngClass]="{
                                            'available': artifact.ArtifactStatus === Available,
                                            'processing': artifact.ArtifactStatus === Processing,
                                            'failed': artifact.ArtifactStatus === Failed,
                                            'to-process': artifact.ArtifactStatus === ToProcess,
                                            'unknown': artifact.ArtifactStatus === Unknown}">
                                            </span>
                                            {{ artifact.ArtifactStatusLocalized }}
                                    </div>                                                
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
                <div *ngIf="catalog.Expanded && catalog.KBArtifacts.length === 0"
                    class="category-container__no-artifacts">{{ 'BASEKNOWLEDGECATALOG.NO_ARTIFACTS' | translate }}</div>
            </div>
            <div *ngIf="category.Expanded && category.KBCatalogs.length === 0  && !(isDevelopment && category.EditMode)"
                class="category-container__no-artifacts">{{ 'BASEKNOWLEDGECATALOG.NO_CATALOGS' | translate }}</div>
        </div>
    
    </div>
    <div *ngIf="filteredCategoryList.length === 0" class="category-container__no-elements">
        <img src="assets/img/no_found.png">
        <span>{{ 'BASEKNOWLEDGECATALOG.NO_ELEMENTS' | translate }}</span>
    </div>
</div>

